'use client';
var classes = {"root":"m_dd36362e","label":"m_c9357328","thumb":"m_c9a9a60a","trackContainer":"m_a8645c2","track":"m_c9ade57f","bar":"m_38aeed47","markWrapper":"m_b7b0423a","mark":"m_dd33bc19","markLabel":"m_68c77a5b"};

export { classes as default };
//# sourceMappingURL=Slider.module.css.mjs.map
